import React from 'react'
import india from './india.gif'
import Resume from './Resume'

function Profile(props) {


  
  return (
  <>
  <div> 
  <div className='tiranga' style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`}}>
  <div className='flag'>
    <img src={india} alt="" />
  </div>
  </div>
     <div id="di1" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`}}>
                <h1 className="hello" style={{color:`${props.mode==='light'?'rgb(11, 117, 117)':'rgb(83, 80, 80)'}`}} >
                      <span className="helloAbout" style={{ color:`${props.mode==='light'?'white':'rgb(11, 117, 117)'}`}} >HELLO </span>  ! 
                    </h1>

                <h2 className="designation">
                    <marquee>
                        𝐹𝒰𝐿𝐿 𝒮𝒯𝒜𝒞𝒦 𝒲𝐸𝐵𝒮𝐼𝒯𝐸 𝒟𝐸𝒱𝐸𝐿𝒫𝐸𝑅
                    </marquee>
                </h2>

                <p className="intro">I am Digvijay, and I am a full stack web developer, ready to take the responsibilities and work
                    with a team in technical ground .</p>

                    <div className='downloadCv'>
                      {/* <a href={Resume}></a> */}
                      <a target='_blank' href="https://drive.google.com/file/d/1ZYSrctDp3b4qldinOKdbr6ZVzBaz2tCF/view?usp=sharing"><button className="button-73" role="button">download cv</button></a>
                    </div>

                      

                    <h1 className="aboutMeHeader" style={{ color:`${props.mode==='light'?'rgb(11, 117, 117)':'rgb(83, 80, 80)'}`}}>
                      <span className="wordAbout" style={{ color:`${props.mode==='light'?'white':'rgb(11, 117, 117)'}`}}>ABOUT </span>  ME 
                    </h1>

                    <p className="about_Discription">
                       Comfotable working in html, css, javascript. preety good in node js, express js, react.
                    </p>

            </div>
         </div>   
      
</>
  )
}

export default Profile